import React from 'react';

interface Props {
  fill?: string;
}

const SearchIcon: React.FC<Props> = ({ fill = '#0A0A0A' }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8778 20.8778L14.3398 14.3398"
        stroke={fill}
        strokeWidth="1.75"
        strokeLinecap="round"
        stroke-Linejoin="round"
      />
      <path
        d="M10.686 16.3759C10.0945 16.5205 9.4762 16.5975 8.8392 16.5975C4.55403 16.5975 1.08203 13.1244 1.08203 8.8392C1.08203 4.55403 4.55403 1.08203 8.8392 1.08203C13.1244 1.08203 16.5975 4.55403 16.5975 8.8392C16.5975 10.9812 15.7284 12.9214 14.3249 14.3249"
        stroke={fill}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SearchIcon;
